import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PathwaySection = () => {
    const navigate = useNavigate();
    const [gridStyle, setGridStyle] = useState({
        display: 'grid',
        gap: '20px',
        gridTemplateColumns: 'repeat(3, 1fr)', // Default: 3 columns
        justifyContent: 'center',
    });

    // Base styles
    const sectionStyle = {
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        textAlign: 'center',
    };

    const headingStyle = {
        fontSize: '1.8rem',
        fontWeight: 'bold',
        marginBottom: '20px',
        color: '#042B4C',
        lineHeight: '1.4',
    };

    const buttonStyle = {
        padding: '15px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        textAlign: 'left',
        cursor: 'pointer',
        backgroundColor: '#f9f9f9',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        transition: 'transform 0.2s, box-shadow 0.2s',
    };

    const buttonHoverStyle = {
        transform: 'translateY(-5px)',
        boxShadow: '0 6px 10px rgba(0, 0, 0, 0.15)',
    };

    const titleStyle = {
        fontSize: '1.2rem',
        marginBottom: '10px',
    };

    const paragraphStyle = {
        fontSize: '0.9rem',
        lineHeight: '1.5',
        color: '#555',
    };

    // Function to update grid style based on screen width
    const updateGridStyle = () => {
        const screenWidth = window.innerWidth;

        if (screenWidth >= 1200) {
            setGridStyle(prevStyle => ({ ...prevStyle, gridTemplateColumns: 'repeat(3, 1fr)' }));
        } else if (screenWidth >= 768) {
            setGridStyle(prevStyle => ({ ...prevStyle, gridTemplateColumns: 'repeat(3, 1fr)' }));
        } else if (screenWidth >= 480) {
            setGridStyle(prevStyle => ({ ...prevStyle, gridTemplateColumns: 'repeat(2, 1fr)' }));
        } else {
            setGridStyle(prevStyle => ({ ...prevStyle, gridTemplateColumns: '1fr' }));
        }
    };

    // Add event listener for window resize
    useEffect(() => {
        updateGridStyle(); // Set initial grid style
        window.addEventListener('resize', updateGridStyle);

        return () => {
            window.removeEventListener('resize', updateGridStyle);
        };
    }, []);

    return (
        <section style={sectionStyle}>
            <h2 style={headingStyle}>
                Your Pathway To Medicine
            </h2>

            <div style={gridStyle}>
                <button
                    style={buttonStyle}
                    onMouseOver={(e) =>
                        Object.assign(e.currentTarget.style, buttonHoverStyle)
                    }
                    onMouseOut={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
                    onClick={() => navigate('/imat-test-breakdown')}
                >
                    <h3 style={titleStyle}>IMAT Test</h3>
                    <p style={paragraphStyle}>
                        Detailed insights into the IMAT test structure along with exclusive
                        scholarship opportunities for high achievers.
                    </p>
                </button>

                <button
                    style={buttonStyle}
                    onMouseOver={(e) =>
                        Object.assign(e.currentTarget.style, buttonHoverStyle)
                    }
                    onMouseOut={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
                    onClick={() => navigate('/global-test-centres')}
                >
                    <h3 style={titleStyle}>Global Test Centres</h3>
                    <p style={paragraphStyle}>
                        Access to multiple IMAT test centres worldwide for convenience and
                        flexibility.
                    </p>
                </button>

                <button
                    style={buttonStyle}
                    onMouseOver={(e) =>
                        Object.assign(e.currentTarget.style, buttonHoverStyle)
                    }
                    onMouseOut={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
                    onClick={() => navigate('/scholarship-opportunities')}
                >
                    <h3 style={titleStyle}>Scholarship</h3>
                    <p style={paragraphStyle}>
                        Our scholarship vision aims to support aspiring medical professionals
                        by reducing financial barriers.
                    </p>
                </button>

                <button
                    style={buttonStyle}
                    onMouseOver={(e) =>
                        Object.assign(e.currentTarget.style, buttonHoverStyle)
                    }
                    onMouseOut={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
                    onClick={() => navigate('/vision-page')}
                >
                    <h3 style={titleStyle}>Our Vision</h3>
                    <p style={paragraphStyle}>
                        Achieve your dream of studying medicine and surgery in your desired
                        university in Italy with expert guidance.
                    </p>
                </button>

                <button
                    style={buttonStyle}
                    onMouseOver={(e) =>
                        Object.assign(e.currentTarget.style, buttonHoverStyle)
                    }
                    onMouseOut={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
                    onClick={() => navigate('/universities-page-dent')}
                >
                    <h3 style={titleStyle}>
                        Universities Offering Dentistry
                    </h3>
                    <p style={paragraphStyle}>
                        Explore top universities in Italy offering Dentistry
                        programs in English.
                    </p>
                </button>

                <button
                    style={buttonStyle}
                    onMouseOver={(e) =>
                        Object.assign(e.currentTarget.style, buttonHoverStyle)
                    }
                    onMouseOut={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
                    onClick={() => navigate('/universities-page')}
                >
                    <h3 style={titleStyle}>
                        Universities Offering Medicine and Surgery
                    </h3>
                    <p style={paragraphStyle}>
                        Explore top universities in Italy offering medicine and surgery
                        programs in English.
                    </p>
                </button>
            </div>
        </section>
    );
};

export default PathwaySection;










// import React from 'react';
// import './PathwaySection.css';
// import { useNavigate } from 'react-router-dom';

// const PathwaySection = () => {
//     const navigate = useNavigate();

//     return (
//         <section className="pathway-section">
//             <h2 className='heading-container'>YOUR PATHWAY TO Medicine : EXPERT IMAT PREPARATION WITH US</h2>
        
//             <div className="pathway-grid">
//                 <button 
//                     className="pathway-btn"
//                     onClick={() => navigate('/imat-test-breakdown')}
//                 >
//                     <h3>IMAT Test Breakdown and Scholarship</h3>
//                     <p>
//                         Detailed insights into the IMAT test structure along with exclusive scholarship opportunities for high achievers.
//                     </p>
//                 </button>
                
//                 <button 
//                     className="pathway-btn"
//                     onClick={() => navigate('/global-test-centres')}
//                 >
//                     <h3>Global Test Centres</h3>
//                     <p>
//                         Access to multiple IMAT test centres worldwide for convenience and flexibility.
//                     </p>
//                 </button>

//                 <button 
//                     className="pathway-btn"
//                     onClick={() => navigate('/ScholarshipOpportunities')}
//                 >
//                     <h3>Scholarship</h3>
//                     <p>
//                         Our scholarship vision aims to support aspiring medical professionals by reducing financial barriers.
//                     </p>
//                 </button>

//                 <button 
//                     className="pathway-btn"
//                     onClick={() => navigate('/VisionPage')}
//                 >
//                     <h3>Vision</h3>
//                     <p>
//                         Achieve your dream of studying medicine and surgery in your desired university in Italy with expert guidance.
//                     </p>
//                 </button>

//                 <button 
//                     className="pathway-btn"
//                     onClick={() => navigate('/UniversitiesPage')}
//                 >
//                     <h3>Universities Offering Medicine and Surgery Programs</h3>
//                     <p>
//                         Explore top universities in Italy offering medicine and surgery programs in English.
//                     </p>
//                 </button>
//             </div>
//         </section>
//     );
// };

// export default PathwaySection;
